/* tslint:disable */
/* eslint-disable */
/**
 * Joule Conductor Cloud
 * This specification document describes the Joule Technologies Application Programming Interface  (API). The endpoints, message formats and status codes are explained in this document. ## Communication  ### Base URI  The base Uniform Resource Identifier (URI) is: https://user-api.joule-cloud.com/v2 This URI is the prefix for all endpoints described in this document. ### Body format  The endpoints of the API expecting a body must be in JavaScript Object Notation (JSON) format.  Response bodies from the endpoints also adhere to this standard, unless otherwise stated.  Responses will include a Content-Type header indicating the ‘application/json’ type. An invalid  or missing body will result in a 400-status code accompanied by an error code to specify the  nature of the error. ### Security The API uses HTTPS as the underlying protocol to transfer data. The server hosts a certificate  to set up a secure connection using Transport Layer Security (TLS) version 1.2. The authenticity  of the server certificate is verifiable by the client using publicly available sources.  #### Authentication and authorization  The API should only be called by legitimate users with the correct access rights. The API uses  the Open Authorization 2.0 (OAuth) standard to achieve this. Every request to the API should  include a bearer access token in the JSON Web Token (JWT) format in the Authorization header.  The header should be formatted such as in the example below.  ```   {“Authorization”: “Bearer <JWT>”}  ``` The JWT must be acquired from one of the following identity providers:   * joule-technologies.eu.auth0.com    * inventum-app.eu.auth0.com    * joule-app.eu.auth0.com   For help regarding gaining an access token you can find the docs for Auth0  [here](https://auth0.com/docs/secure/tokens/access-tokens/get-access-tokens). The JWT must be intended for one of the following audiences:    * https://user-api.joule-cloud.com   If the authorization header does not match the requirements stated above the API will respond  with a 401-status code accompanied by an error code to specify the nature of the error.  ### Timeout The API specifies a maximum amount of time between a request and the response to avoid blocking  either side. The general timeout that has been set for each endpoint is 3000 milliseconds.  This timeout is used unless otherwise stated in the respective endpoint documentation.  If the server is unable to respond within this maximum time, the response contains a 504-status  code. The client may retry the request. The time out for a stream to be open is 1800 seconds.  If the stream is still open passed the experitation the server will close the stream. ### Rate limits  No rate limit is currently imposed. ### Diagnostics response  The diagnostics response provides the caller of the API with more information in case of a  failed request. This information can be used for debugging and recovery/retrying purposes.  The diagnostics response is always included under the “diagnostics” key if the response  has a body. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DisplayBrightnessResponse } from './DisplayBrightnessResponse';
import {
    DisplayBrightnessResponseFromJSON,
    DisplayBrightnessResponseFromJSONTyped,
    DisplayBrightnessResponseToJSON,
    DisplayBrightnessResponseToJSONTyped,
} from './DisplayBrightnessResponse';
import type { PreheatSetpointResponse } from './PreheatSetpointResponse';
import {
    PreheatSetpointResponseFromJSON,
    PreheatSetpointResponseFromJSONTyped,
    PreheatSetpointResponseToJSON,
    PreheatSetpointResponseToJSONTyped,
} from './PreheatSetpointResponse';
import type { SharingPolicyResponse } from './SharingPolicyResponse';
import {
    SharingPolicyResponseFromJSON,
    SharingPolicyResponseFromJSONTyped,
    SharingPolicyResponseToJSON,
    SharingPolicyResponseToJSONTyped,
} from './SharingPolicyResponse';
import type { ErrorsResponse } from './ErrorsResponse';
import {
    ErrorsResponseFromJSON,
    ErrorsResponseFromJSONTyped,
    ErrorsResponseToJSON,
    ErrorsResponseToJSONTyped,
} from './ErrorsResponse';
import type { RemoteLoggingResponse } from './RemoteLoggingResponse';
import {
    RemoteLoggingResponseFromJSON,
    RemoteLoggingResponseFromJSONTyped,
    RemoteLoggingResponseToJSON,
    RemoteLoggingResponseToJSONTyped,
} from './RemoteLoggingResponse';
import type { WeekscheduleResponse } from './WeekscheduleResponse';
import {
    WeekscheduleResponseFromJSON,
    WeekscheduleResponseFromJSONTyped,
    WeekscheduleResponseToJSON,
    WeekscheduleResponseToJSONTyped,
} from './WeekscheduleResponse';
import type { DeviceInfoResponse } from './DeviceInfoResponse';
import {
    DeviceInfoResponseFromJSON,
    DeviceInfoResponseFromJSONTyped,
    DeviceInfoResponseToJSON,
    DeviceInfoResponseToJSONTyped,
} from './DeviceInfoResponse';
import type { FlameStateResponse } from './FlameStateResponse';
import {
    FlameStateResponseFromJSON,
    FlameStateResponseFromJSONTyped,
    FlameStateResponseToJSON,
    FlameStateResponseToJSONTyped,
} from './FlameStateResponse';
import type { FilterStateResponse } from './FilterStateResponse';
import {
    FilterStateResponseFromJSON,
    FilterStateResponseFromJSONTyped,
    FilterStateResponseToJSON,
    FilterStateResponseToJSONTyped,
} from './FilterStateResponse';
import type { HeatPumpSetupResponse } from './HeatPumpSetupResponse';
import {
    HeatPumpSetupResponseFromJSON,
    HeatPumpSetupResponseFromJSONTyped,
    HeatPumpSetupResponseToJSON,
    HeatPumpSetupResponseToJSONTyped,
} from './HeatPumpSetupResponse';
import type { WeekscheduleStateResponse } from './WeekscheduleStateResponse';
import {
    WeekscheduleStateResponseFromJSON,
    WeekscheduleStateResponseFromJSONTyped,
    WeekscheduleStateResponseToJSON,
    WeekscheduleStateResponseToJSONTyped,
} from './WeekscheduleStateResponse';
import type { DevicesChanged } from './DevicesChanged';
import {
    DevicesChangedFromJSON,
    DevicesChangedFromJSONTyped,
    DevicesChangedToJSON,
    DevicesChangedToJSONTyped,
} from './DevicesChanged';
import type { VentilationResponse } from './VentilationResponse';
import {
    VentilationResponseFromJSON,
    VentilationResponseFromJSONTyped,
    VentilationResponseToJSON,
    VentilationResponseToJSONTyped,
} from './VentilationResponse';
import type { AmbientOffsetResponse } from './AmbientOffsetResponse';
import {
    AmbientOffsetResponseFromJSON,
    AmbientOffsetResponseFromJSONTyped,
    AmbientOffsetResponseToJSON,
    AmbientOffsetResponseToJSONTyped,
} from './AmbientOffsetResponse';
import type { ClimateModeResponse } from './ClimateModeResponse';
import {
    ClimateModeResponseFromJSON,
    ClimateModeResponseFromJSONTyped,
    ClimateModeResponseToJSON,
    ClimateModeResponseToJSONTyped,
} from './ClimateModeResponse';
import type { LegionellaResponse } from './LegionellaResponse';
import {
    LegionellaResponseFromJSON,
    LegionellaResponseFromJSONTyped,
    LegionellaResponseToJSON,
    LegionellaResponseToJSONTyped,
} from './LegionellaResponse';
import type { DiagnosticsEmbed } from './DiagnosticsEmbed';
import {
    DiagnosticsEmbedFromJSON,
    DiagnosticsEmbedFromJSONTyped,
    DiagnosticsEmbedToJSON,
    DiagnosticsEmbedToJSONTyped,
} from './DiagnosticsEmbed';
import type { SettingsResponse } from './SettingsResponse';
import {
    SettingsResponseFromJSON,
    SettingsResponseFromJSONTyped,
    SettingsResponseToJSON,
    SettingsResponseToJSONTyped,
} from './SettingsResponse';
import type { DhwBoostResponse } from './DhwBoostResponse';
import {
    DhwBoostResponseFromJSON,
    DhwBoostResponseFromJSONTyped,
    DhwBoostResponseToJSON,
    DhwBoostResponseToJSONTyped,
} from './DhwBoostResponse';
import type { HistoryDataPointItem } from './HistoryDataPointItem';
import {
    HistoryDataPointItemFromJSON,
    HistoryDataPointItemFromJSONTyped,
    HistoryDataPointItemToJSON,
    HistoryDataPointItemToJSONTyped,
} from './HistoryDataPointItem';
import type { DhwPreferencesResponse } from './DhwPreferencesResponse';
import {
    DhwPreferencesResponseFromJSON,
    DhwPreferencesResponseFromJSONTyped,
    DhwPreferencesResponseToJSON,
    DhwPreferencesResponseToJSONTyped,
} from './DhwPreferencesResponse';
import type { BoilerControlModeResponse } from './BoilerControlModeResponse';
import {
    BoilerControlModeResponseFromJSON,
    BoilerControlModeResponseFromJSONTyped,
    BoilerControlModeResponseToJSON,
    BoilerControlModeResponseToJSONTyped,
} from './BoilerControlModeResponse';
import type { RoomSetpointResponse } from './RoomSetpointResponse';
import {
    RoomSetpointResponseFromJSON,
    RoomSetpointResponseFromJSONTyped,
    RoomSetpointResponseToJSON,
    RoomSetpointResponseToJSONTyped,
} from './RoomSetpointResponse';
import type { Sensor } from './Sensor';
import {
    SensorFromJSON,
    SensorFromJSONTyped,
    SensorToJSON,
    SensorToJSONTyped,
} from './Sensor';

/**
 * 
 * @export
 * @interface GetSystemStream200Response
 */
export interface GetSystemStream200Response {
    /**
     * 
     * @type {AmbientOffsetResponse}
     * @memberof GetSystemStream200Response
     */
    ambientOffset?: AmbientOffsetResponse;
    /**
     * 
     * @type {BoilerControlModeResponse}
     * @memberof GetSystemStream200Response
     */
    boilerControlMode?: BoilerControlModeResponse;
    /**
     * 
     * @type {ClimateModeResponse}
     * @memberof GetSystemStream200Response
     */
    climateMode?: ClimateModeResponse;
    /**
     * 
     * @type {DeviceInfoResponse}
     * @memberof GetSystemStream200Response
     */
    deviceInfo?: DeviceInfoResponse;
    /**
     * 
     * @type {DhwBoostResponse}
     * @memberof GetSystemStream200Response
     */
    dhwBoost?: DhwBoostResponse;
    /**
     * 
     * @type {DhwPreferencesResponse}
     * @memberof GetSystemStream200Response
     */
    dhwPreferences?: DhwPreferencesResponse;
    /**
     * 
     * @type {DisplayBrightnessResponse}
     * @memberof GetSystemStream200Response
     */
    displayBrightness?: DisplayBrightnessResponse;
    /**
     * 
     * @type {ErrorsResponse}
     * @memberof GetSystemStream200Response
     */
    errors?: ErrorsResponse;
    /**
     * 
     * @type {FilterStateResponse}
     * @memberof GetSystemStream200Response
     */
    filterState?: FilterStateResponse;
    /**
     * 
     * @type {FlameStateResponse}
     * @memberof GetSystemStream200Response
     */
    flameState?: FlameStateResponse;
    /**
     * 
     * @type {HeatPumpSetupResponse}
     * @memberof GetSystemStream200Response
     */
    heatPumpSetup?: HeatPumpSetupResponse;
    /**
     * 
     * @type {LegionellaResponse}
     * @memberof GetSystemStream200Response
     */
    legionella?: LegionellaResponse;
    /**
     * 
     * @type {PreheatSetpointResponse}
     * @memberof GetSystemStream200Response
     */
    preheatSetpoint?: PreheatSetpointResponse;
    /**
     * 
     * @type {RemoteLoggingResponse}
     * @memberof GetSystemStream200Response
     */
    remoteLogging?: RemoteLoggingResponse;
    /**
     * 
     * @type {RoomSetpointResponse}
     * @memberof GetSystemStream200Response
     */
    roomSetpoint?: RoomSetpointResponse;
    /**
     * 
     * @type {SettingsResponse}
     * @memberof GetSystemStream200Response
     */
    settings?: SettingsResponse;
    /**
     * 
     * @type {SharingPolicyResponse}
     * @memberof GetSystemStream200Response
     */
    sharingPolicy?: SharingPolicyResponse;
    /**
     * 
     * @type {VentilationResponse}
     * @memberof GetSystemStream200Response
     */
    ventilation?: VentilationResponse;
    /**
     * 
     * @type {WeekscheduleResponse}
     * @memberof GetSystemStream200Response
     */
    weekschedule?: WeekscheduleResponse;
    /**
     * 
     * @type {WeekscheduleStateResponse}
     * @memberof GetSystemStream200Response
     */
    weekscheduleState?: WeekscheduleStateResponse;
    /**
     * 
     * @type {DiagnosticsEmbed}
     * @memberof GetSystemStream200Response
     */
    diagnostics?: DiagnosticsEmbed;
    /**
     * The possible sensor names are:
     *  * temperature
     *  * humidity
     *  * eco2
     *  * tvoc
     * 
     * @type {{ [key: string]: Sensor; }}
     * @memberof GetSystemStream200Response
     */
    sensors?: { [key: string]: Sensor; };
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    airAs200SensorState?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    airDuctsPosition?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    airExhaustTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    airExternalTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    airFanSpeed?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    airFlowSetpoint?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    airIndoorHumidity?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    airOutdoorTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    airReturnSpeed?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    airReturnTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    airThermalResistance?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    airVentilationFlow?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    ambientEco2?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    ambientHumidity?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    ambientTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    ambientTvoc?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    antiFreezeProtectionActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    backupHeater1Active?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    backupHeater2Active?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    backupHeater3Active?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    boilerDemandActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    boilerDhwValveState?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    boilerElementActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    boilerNtc1Temperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    boilerNtc2Temperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    boilerNtc3Temperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    boilerNtc4Temperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    boilerValveZone1StateActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    boilerValveZone2StateActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    boilerValveZone3StateActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    centralHeatingEnabled?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    centralHeatingOrDomesticHotWaterActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    centralHeatingPumpOperationHours?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    centralHeatingPumpPwm?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    centralHeatingPumpStartStopCount?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    centralHeatingTemperatureTooHigh?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    centralHeatingTotalEnergyConsumed?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    centralHeatingWaterPressure?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    compressorAntiToggleActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    compressorEnabled?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    compressorOperationHours?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    compressorTotalEnergyConsumed?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    connected?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    cop?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    disconnectReason?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    externalAirExhaustFlow?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    externalAirIntakeFlow?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    externalTemperatureSensorActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    filterChangeRequiredWithinDays?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpAirExhaustTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpAuxiliaryHeatingDegreeMinutes?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpCondensationPressure?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpCondensationTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpCondenserRefrigerantOutTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpCurrentCompressorSpeed?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpDefrostFreezingValue?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpDefrostFreezingValueThreshold?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpDesiredAirIndoorValveSetpoint?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpDesiredAirOutdoorValveSetpoint?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpDesiredCompressorSpeed?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpDesiredReverseCyclePositionIsCooling?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpDeterminedAirFanSpeedSetpoint?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpDeterminedAirIndoorValvePosition?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpDeterminedAirOutdoorValvePosition?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpDeterminedCentralHeatingSupplyTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpDeterminedCompressorSpeed?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpDeterminedSuperheatExpansionValvePosition?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpDeterminedWaterPumpSpeedSetpoint?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpEvaporationPressure?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpEvaporationTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpEvaporatorRefrigerantOutTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpHotGasTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpInverterFaultCode?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpInverterInputPower?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpMaximumCompressorSpeedEnvelope?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpMaximumCompressorSpeedHotgas?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpMinimumCompressorSpeedEnvelope?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpRoomSetpointTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpSpareTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatPumpTotalOperationHours?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatRecoveryValveCentralHeatingActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    heatRecoveryValveHalfActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    hotWaterCapacity?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    hotWaterSetpoint?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    hotWaterTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    internalAirIntakeFlow?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    legionellaPreventionActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    nightclockActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    performanceEnergyConsumptionL1?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    performanceEnergyConsumptionL2?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    performanceEnergyConsumptionL3?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    performancePowerUsageL1?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    performancePowerUsageL2?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    performancePowerUsageL3?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    pureAirAirInTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    pureAirAirOutTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    pureAirDeterminedFanSpeedSetpoint?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    pureAirEstimatedWaterValvePosition?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    pureAirFanSpeed?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    requestedHeatingTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    reverseCyclePositionIsCooling?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    roomCurrentUba?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    suppliedEnergyCentralHeating?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    suppliedEnergyDomesticHotWater?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    suppliedEnergyHeatRecoveryModule?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    systemActive?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    thermostatHybridChEnable?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    ventilationRequestedAutoDemand?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    ventilationTotalEnergyConsumed?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    ventilatorOperationHours?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    ventilatorPwm?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    waterCondenserWaterOutTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    waterFlow?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    waterPumpFlow?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    waterPumpStatus?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    waterReturnTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {HistoryDataPointItem}
     * @memberof GetSystemStream200Response
     */
    waterSupplyTemperature?: HistoryDataPointItem;
    /**
     * 
     * @type {string}
     * @memberof GetSystemStream200Response
     */
    deviceId: string;
    /**
     * 
     * @type {DevicesChanged}
     * @memberof GetSystemStream200Response
     */
    deviceChanged?: DevicesChanged;
}

/**
 * Check if a given object implements the GetSystemStream200Response interface.
 */
export function instanceOfGetSystemStream200Response(value: object): value is GetSystemStream200Response {
    if (!('deviceId' in value) || value['deviceId'] === undefined) return false;
    return true;
}

export function GetSystemStream200ResponseFromJSON(json: any): GetSystemStream200Response {
    return GetSystemStream200ResponseFromJSONTyped(json, false);
}

export function GetSystemStream200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSystemStream200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'ambientOffset': json['ambient_offset'] == null ? undefined : AmbientOffsetResponseFromJSON(json['ambient_offset']),
        'boilerControlMode': json['boiler_control_mode'] == null ? undefined : BoilerControlModeResponseFromJSON(json['boiler_control_mode']),
        'climateMode': json['climate_mode'] == null ? undefined : ClimateModeResponseFromJSON(json['climate_mode']),
        'deviceInfo': json['device_info'] == null ? undefined : DeviceInfoResponseFromJSON(json['device_info']),
        'dhwBoost': json['dhw_boost'] == null ? undefined : DhwBoostResponseFromJSON(json['dhw_boost']),
        'dhwPreferences': json['dhw_preferences'] == null ? undefined : DhwPreferencesResponseFromJSON(json['dhw_preferences']),
        'displayBrightness': json['display_brightness'] == null ? undefined : DisplayBrightnessResponseFromJSON(json['display_brightness']),
        'errors': json['errors'] == null ? undefined : ErrorsResponseFromJSON(json['errors']),
        'filterState': json['filter_state'] == null ? undefined : FilterStateResponseFromJSON(json['filter_state']),
        'flameState': json['flame_state'] == null ? undefined : FlameStateResponseFromJSON(json['flame_state']),
        'heatPumpSetup': json['heat_pump_setup'] == null ? undefined : HeatPumpSetupResponseFromJSON(json['heat_pump_setup']),
        'legionella': json['legionella'] == null ? undefined : LegionellaResponseFromJSON(json['legionella']),
        'preheatSetpoint': json['preheat_setpoint'] == null ? undefined : PreheatSetpointResponseFromJSON(json['preheat_setpoint']),
        'remoteLogging': json['remote_logging'] == null ? undefined : RemoteLoggingResponseFromJSON(json['remote_logging']),
        'roomSetpoint': json['room_setpoint'] == null ? undefined : RoomSetpointResponseFromJSON(json['room_setpoint']),
        'settings': json['settings'] == null ? undefined : SettingsResponseFromJSON(json['settings']),
        'sharingPolicy': json['sharing_policy'] == null ? undefined : SharingPolicyResponseFromJSON(json['sharing_policy']),
        'ventilation': json['ventilation'] == null ? undefined : VentilationResponseFromJSON(json['ventilation']),
        'weekschedule': json['weekschedule'] == null ? undefined : WeekscheduleResponseFromJSON(json['weekschedule']),
        'weekscheduleState': json['weekschedule_state'] == null ? undefined : WeekscheduleStateResponseFromJSON(json['weekschedule_state']),
        'diagnostics': json['diagnostics'] == null ? undefined : DiagnosticsEmbedFromJSON(json['diagnostics']),
        'sensors': json['sensors'] == null ? undefined : (mapValues(json['sensors'], SensorFromJSON)),
        'airAs200SensorState': json['air_as200_sensor_state'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_as200_sensor_state']),
        'airDuctsPosition': json['air_ducts_position'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_ducts_position']),
        'airExhaustTemperature': json['air_exhaust_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_exhaust_temperature']),
        'airExternalTemperature': json['air_external_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_external_temperature']),
        'airFanSpeed': json['air_fan_speed'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_fan_speed']),
        'airFlowSetpoint': json['air_flow_setpoint'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_flow_setpoint']),
        'airIndoorHumidity': json['air_indoor_humidity'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_indoor_humidity']),
        'airOutdoorTemperature': json['air_outdoor_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_outdoor_temperature']),
        'airReturnSpeed': json['air_return_speed'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_return_speed']),
        'airReturnTemperature': json['air_return_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_return_temperature']),
        'airThermalResistance': json['air_thermal_resistance'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_thermal_resistance']),
        'airVentilationFlow': json['air_ventilation_flow'] == null ? undefined : HistoryDataPointItemFromJSON(json['air_ventilation_flow']),
        'ambientEco2': json['ambient_eco2'] == null ? undefined : HistoryDataPointItemFromJSON(json['ambient_eco2']),
        'ambientHumidity': json['ambient_humidity'] == null ? undefined : HistoryDataPointItemFromJSON(json['ambient_humidity']),
        'ambientTemperature': json['ambient_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['ambient_temperature']),
        'ambientTvoc': json['ambient_tvoc'] == null ? undefined : HistoryDataPointItemFromJSON(json['ambient_tvoc']),
        'antiFreezeProtectionActive': json['anti_freeze_protection_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['anti_freeze_protection_active']),
        'backupHeater1Active': json['backup_heater_1_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['backup_heater_1_active']),
        'backupHeater2Active': json['backup_heater_2_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['backup_heater_2_active']),
        'backupHeater3Active': json['backup_heater_3_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['backup_heater_3_active']),
        'boilerDemandActive': json['boiler_demand_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_demand_active']),
        'boilerDhwValveState': json['boiler_dhw_valve_state'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_dhw_valve_state']),
        'boilerElementActive': json['boiler_element_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_element_active']),
        'boilerNtc1Temperature': json['boiler_ntc_1_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_ntc_1_temperature']),
        'boilerNtc2Temperature': json['boiler_ntc_2_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_ntc_2_temperature']),
        'boilerNtc3Temperature': json['boiler_ntc_3_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_ntc_3_temperature']),
        'boilerNtc4Temperature': json['boiler_ntc_4_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_ntc_4_temperature']),
        'boilerValveZone1StateActive': json['boiler_valve_zone_1_state_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_valve_zone_1_state_active']),
        'boilerValveZone2StateActive': json['boiler_valve_zone_2_state_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_valve_zone_2_state_active']),
        'boilerValveZone3StateActive': json['boiler_valve_zone_3_state_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['boiler_valve_zone_3_state_active']),
        'centralHeatingEnabled': json['central_heating_enabled'] == null ? undefined : HistoryDataPointItemFromJSON(json['central_heating_enabled']),
        'centralHeatingOrDomesticHotWaterActive': json['central_heating_or_domestic_hot_water_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['central_heating_or_domestic_hot_water_active']),
        'centralHeatingPumpOperationHours': json['central_heating_pump_operation_hours'] == null ? undefined : HistoryDataPointItemFromJSON(json['central_heating_pump_operation_hours']),
        'centralHeatingPumpPwm': json['central_heating_pump_pwm'] == null ? undefined : HistoryDataPointItemFromJSON(json['central_heating_pump_pwm']),
        'centralHeatingPumpStartStopCount': json['central_heating_pump_start_stop_count'] == null ? undefined : HistoryDataPointItemFromJSON(json['central_heating_pump_start_stop_count']),
        'centralHeatingTemperatureTooHigh': json['central_heating_temperature_too_high'] == null ? undefined : HistoryDataPointItemFromJSON(json['central_heating_temperature_too_high']),
        'centralHeatingTotalEnergyConsumed': json['central_heating_total_energy_consumed'] == null ? undefined : HistoryDataPointItemFromJSON(json['central_heating_total_energy_consumed']),
        'centralHeatingWaterPressure': json['central_heating_water_pressure'] == null ? undefined : HistoryDataPointItemFromJSON(json['central_heating_water_pressure']),
        'compressorAntiToggleActive': json['compressor_anti_toggle_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['compressor_anti_toggle_active']),
        'compressorEnabled': json['compressor_enabled'] == null ? undefined : HistoryDataPointItemFromJSON(json['compressor_enabled']),
        'compressorOperationHours': json['compressor_operation_hours'] == null ? undefined : HistoryDataPointItemFromJSON(json['compressor_operation_hours']),
        'compressorTotalEnergyConsumed': json['compressor_total_energy_consumed'] == null ? undefined : HistoryDataPointItemFromJSON(json['compressor_total_energy_consumed']),
        'connected': json['connected'] == null ? undefined : HistoryDataPointItemFromJSON(json['connected']),
        'cop': json['cop'] == null ? undefined : HistoryDataPointItemFromJSON(json['cop']),
        'disconnectReason': json['disconnect_reason'] == null ? undefined : HistoryDataPointItemFromJSON(json['disconnect_reason']),
        'externalAirExhaustFlow': json['external_air_exhaust_flow'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_air_exhaust_flow']),
        'externalAirIntakeFlow': json['external_air_intake_flow'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_air_intake_flow']),
        'externalTemperatureSensorActive': json['external_temperature_sensor_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['external_temperature_sensor_active']),
        'filterChangeRequiredWithinDays': json['filter_change_required_within_days'] == null ? undefined : HistoryDataPointItemFromJSON(json['filter_change_required_within_days']),
        'heatPumpAirExhaustTemperature': json['heat_pump_air_exhaust_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_air_exhaust_temperature']),
        'heatPumpAuxiliaryHeatingDegreeMinutes': json['heat_pump_auxiliary_heating_degree_minutes'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_auxiliary_heating_degree_minutes']),
        'heatPumpCondensationPressure': json['heat_pump_condensation_pressure'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_condensation_pressure']),
        'heatPumpCondensationTemperature': json['heat_pump_condensation_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_condensation_temperature']),
        'heatPumpCondenserRefrigerantOutTemperature': json['heat_pump_condenser_refrigerant_out_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_condenser_refrigerant_out_temperature']),
        'heatPumpCurrentCompressorSpeed': json['heat_pump_current_compressor_speed'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_current_compressor_speed']),
        'heatPumpDefrostFreezingValue': json['heat_pump_defrost_freezing_value'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_defrost_freezing_value']),
        'heatPumpDefrostFreezingValueThreshold': json['heat_pump_defrost_freezing_value_threshold'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_defrost_freezing_value_threshold']),
        'heatPumpDesiredAirIndoorValveSetpoint': json['heat_pump_desired_air_indoor_valve_setpoint'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_desired_air_indoor_valve_setpoint']),
        'heatPumpDesiredAirOutdoorValveSetpoint': json['heat_pump_desired_air_outdoor_valve_setpoint'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_desired_air_outdoor_valve_setpoint']),
        'heatPumpDesiredCompressorSpeed': json['heat_pump_desired_compressor_speed'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_desired_compressor_speed']),
        'heatPumpDesiredReverseCyclePositionIsCooling': json['heat_pump_desired_reverse_cycle_position_is_cooling'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_desired_reverse_cycle_position_is_cooling']),
        'heatPumpDeterminedAirFanSpeedSetpoint': json['heat_pump_determined_air_fan_speed_setpoint'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_determined_air_fan_speed_setpoint']),
        'heatPumpDeterminedAirIndoorValvePosition': json['heat_pump_determined_air_indoor_valve_position'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_determined_air_indoor_valve_position']),
        'heatPumpDeterminedAirOutdoorValvePosition': json['heat_pump_determined_air_outdoor_valve_position'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_determined_air_outdoor_valve_position']),
        'heatPumpDeterminedCentralHeatingSupplyTemperature': json['heat_pump_determined_central_heating_supply_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_determined_central_heating_supply_temperature']),
        'heatPumpDeterminedCompressorSpeed': json['heat_pump_determined_compressor_speed'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_determined_compressor_speed']),
        'heatPumpDeterminedSuperheatExpansionValvePosition': json['heat_pump_determined_superheat_expansion_valve_position'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_determined_superheat_expansion_valve_position']),
        'heatPumpDeterminedWaterPumpSpeedSetpoint': json['heat_pump_determined_water_pump_speed_setpoint'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_determined_water_pump_speed_setpoint']),
        'heatPumpEvaporationPressure': json['heat_pump_evaporation_pressure'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_evaporation_pressure']),
        'heatPumpEvaporationTemperature': json['heat_pump_evaporation_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_evaporation_temperature']),
        'heatPumpEvaporatorRefrigerantOutTemperature': json['heat_pump_evaporator_refrigerant_out_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_evaporator_refrigerant_out_temperature']),
        'heatPumpHotGasTemperature': json['heat_pump_hot_gas_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_hot_gas_temperature']),
        'heatPumpInverterFaultCode': json['heat_pump_inverter_fault_code'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_inverter_fault_code']),
        'heatPumpInverterInputPower': json['heat_pump_inverter_input_power'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_inverter_input_power']),
        'heatPumpMaximumCompressorSpeedEnvelope': json['heat_pump_maximum_compressor_speed_envelope'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_maximum_compressor_speed_envelope']),
        'heatPumpMaximumCompressorSpeedHotgas': json['heat_pump_maximum_compressor_speed_hotgas'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_maximum_compressor_speed_hotgas']),
        'heatPumpMinimumCompressorSpeedEnvelope': json['heat_pump_minimum_compressor_speed_envelope'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_minimum_compressor_speed_envelope']),
        'heatPumpRoomSetpointTemperature': json['heat_pump_room_setpoint_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_room_setpoint_temperature']),
        'heatPumpSpareTemperature': json['heat_pump_spare_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_spare_temperature']),
        'heatPumpTotalOperationHours': json['heat_pump_total_operation_hours'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_pump_total_operation_hours']),
        'heatRecoveryValveCentralHeatingActive': json['heat_recovery_valve_central_heating_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_recovery_valve_central_heating_active']),
        'heatRecoveryValveHalfActive': json['heat_recovery_valve_half_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['heat_recovery_valve_half_active']),
        'hotWaterCapacity': json['hot_water_capacity'] == null ? undefined : HistoryDataPointItemFromJSON(json['hot_water_capacity']),
        'hotWaterSetpoint': json['hot_water_setpoint'] == null ? undefined : HistoryDataPointItemFromJSON(json['hot_water_setpoint']),
        'hotWaterTemperature': json['hot_water_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['hot_water_temperature']),
        'internalAirIntakeFlow': json['internal_air_intake_flow'] == null ? undefined : HistoryDataPointItemFromJSON(json['internal_air_intake_flow']),
        'legionellaPreventionActive': json['legionella_prevention_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['legionella_prevention_active']),
        'nightclockActive': json['nightclock_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['nightclock_active']),
        'performanceEnergyConsumptionL1': json['performance_energy_consumption_l1'] == null ? undefined : HistoryDataPointItemFromJSON(json['performance_energy_consumption_l1']),
        'performanceEnergyConsumptionL2': json['performance_energy_consumption_l2'] == null ? undefined : HistoryDataPointItemFromJSON(json['performance_energy_consumption_l2']),
        'performanceEnergyConsumptionL3': json['performance_energy_consumption_l3'] == null ? undefined : HistoryDataPointItemFromJSON(json['performance_energy_consumption_l3']),
        'performancePowerUsageL1': json['performance_power_usage_l1'] == null ? undefined : HistoryDataPointItemFromJSON(json['performance_power_usage_l1']),
        'performancePowerUsageL2': json['performance_power_usage_l2'] == null ? undefined : HistoryDataPointItemFromJSON(json['performance_power_usage_l2']),
        'performancePowerUsageL3': json['performance_power_usage_l3'] == null ? undefined : HistoryDataPointItemFromJSON(json['performance_power_usage_l3']),
        'pureAirAirInTemperature': json['pure_air_air_in_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['pure_air_air_in_temperature']),
        'pureAirAirOutTemperature': json['pure_air_air_out_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['pure_air_air_out_temperature']),
        'pureAirDeterminedFanSpeedSetpoint': json['pure_air_determined_fan_speed_setpoint'] == null ? undefined : HistoryDataPointItemFromJSON(json['pure_air_determined_fan_speed_setpoint']),
        'pureAirEstimatedWaterValvePosition': json['pure_air_estimated_water_valve_position'] == null ? undefined : HistoryDataPointItemFromJSON(json['pure_air_estimated_water_valve_position']),
        'pureAirFanSpeed': json['pure_air_fan_speed'] == null ? undefined : HistoryDataPointItemFromJSON(json['pure_air_fan_speed']),
        'requestedHeatingTemperature': json['requested_heating_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['requested_heating_temperature']),
        'reverseCyclePositionIsCooling': json['reverse_cycle_position_is_cooling'] == null ? undefined : HistoryDataPointItemFromJSON(json['reverse_cycle_position_is_cooling']),
        'roomCurrentUba': json['room_current_uba'] == null ? undefined : HistoryDataPointItemFromJSON(json['room_current_uba']),
        'suppliedEnergyCentralHeating': json['supplied_energy_central_heating'] == null ? undefined : HistoryDataPointItemFromJSON(json['supplied_energy_central_heating']),
        'suppliedEnergyDomesticHotWater': json['supplied_energy_domestic_hot_water'] == null ? undefined : HistoryDataPointItemFromJSON(json['supplied_energy_domestic_hot_water']),
        'suppliedEnergyHeatRecoveryModule': json['supplied_energy_heat_recovery_module'] == null ? undefined : HistoryDataPointItemFromJSON(json['supplied_energy_heat_recovery_module']),
        'systemActive': json['system_active'] == null ? undefined : HistoryDataPointItemFromJSON(json['system_active']),
        'thermostatHybridChEnable': json['thermostat_hybrid_ch_enable'] == null ? undefined : HistoryDataPointItemFromJSON(json['thermostat_hybrid_ch_enable']),
        'ventilationRequestedAutoDemand': json['ventilation_requested_auto_demand'] == null ? undefined : HistoryDataPointItemFromJSON(json['ventilation_requested_auto_demand']),
        'ventilationTotalEnergyConsumed': json['ventilation_total_energy_consumed'] == null ? undefined : HistoryDataPointItemFromJSON(json['ventilation_total_energy_consumed']),
        'ventilatorOperationHours': json['ventilator_operation_hours'] == null ? undefined : HistoryDataPointItemFromJSON(json['ventilator_operation_hours']),
        'ventilatorPwm': json['ventilator_pwm'] == null ? undefined : HistoryDataPointItemFromJSON(json['ventilator_pwm']),
        'waterCondenserWaterOutTemperature': json['water_condenser_water_out_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['water_condenser_water_out_temperature']),
        'waterFlow': json['water_flow'] == null ? undefined : HistoryDataPointItemFromJSON(json['water_flow']),
        'waterPumpFlow': json['water_pump_flow'] == null ? undefined : HistoryDataPointItemFromJSON(json['water_pump_flow']),
        'waterPumpStatus': json['water_pump_status'] == null ? undefined : HistoryDataPointItemFromJSON(json['water_pump_status']),
        'waterReturnTemperature': json['water_return_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['water_return_temperature']),
        'waterSupplyTemperature': json['water_supply_temperature'] == null ? undefined : HistoryDataPointItemFromJSON(json['water_supply_temperature']),
        'deviceId': json['device_id'],
        'deviceChanged': json['device_changed'] == null ? undefined : DevicesChangedFromJSON(json['device_changed']),
    };
}

export function GetSystemStream200ResponseToJSON(json: any): GetSystemStream200Response {
    return GetSystemStream200ResponseToJSONTyped(json, false);
}

export function GetSystemStream200ResponseToJSONTyped(value?: GetSystemStream200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ambient_offset': AmbientOffsetResponseToJSON(value['ambientOffset']),
        'boiler_control_mode': BoilerControlModeResponseToJSON(value['boilerControlMode']),
        'climate_mode': ClimateModeResponseToJSON(value['climateMode']),
        'device_info': DeviceInfoResponseToJSON(value['deviceInfo']),
        'dhw_boost': DhwBoostResponseToJSON(value['dhwBoost']),
        'dhw_preferences': DhwPreferencesResponseToJSON(value['dhwPreferences']),
        'display_brightness': DisplayBrightnessResponseToJSON(value['displayBrightness']),
        'errors': ErrorsResponseToJSON(value['errors']),
        'filter_state': FilterStateResponseToJSON(value['filterState']),
        'flame_state': FlameStateResponseToJSON(value['flameState']),
        'heat_pump_setup': HeatPumpSetupResponseToJSON(value['heatPumpSetup']),
        'legionella': LegionellaResponseToJSON(value['legionella']),
        'preheat_setpoint': PreheatSetpointResponseToJSON(value['preheatSetpoint']),
        'remote_logging': RemoteLoggingResponseToJSON(value['remoteLogging']),
        'room_setpoint': RoomSetpointResponseToJSON(value['roomSetpoint']),
        'settings': SettingsResponseToJSON(value['settings']),
        'sharing_policy': SharingPolicyResponseToJSON(value['sharingPolicy']),
        'ventilation': VentilationResponseToJSON(value['ventilation']),
        'weekschedule': WeekscheduleResponseToJSON(value['weekschedule']),
        'weekschedule_state': WeekscheduleStateResponseToJSON(value['weekscheduleState']),
        'diagnostics': DiagnosticsEmbedToJSON(value['diagnostics']),
        'sensors': value['sensors'] == null ? undefined : (mapValues(value['sensors'], SensorToJSON)),
        'air_as200_sensor_state': HistoryDataPointItemToJSON(value['airAs200SensorState']),
        'air_ducts_position': HistoryDataPointItemToJSON(value['airDuctsPosition']),
        'air_exhaust_temperature': HistoryDataPointItemToJSON(value['airExhaustTemperature']),
        'air_external_temperature': HistoryDataPointItemToJSON(value['airExternalTemperature']),
        'air_fan_speed': HistoryDataPointItemToJSON(value['airFanSpeed']),
        'air_flow_setpoint': HistoryDataPointItemToJSON(value['airFlowSetpoint']),
        'air_indoor_humidity': HistoryDataPointItemToJSON(value['airIndoorHumidity']),
        'air_outdoor_temperature': HistoryDataPointItemToJSON(value['airOutdoorTemperature']),
        'air_return_speed': HistoryDataPointItemToJSON(value['airReturnSpeed']),
        'air_return_temperature': HistoryDataPointItemToJSON(value['airReturnTemperature']),
        'air_thermal_resistance': HistoryDataPointItemToJSON(value['airThermalResistance']),
        'air_ventilation_flow': HistoryDataPointItemToJSON(value['airVentilationFlow']),
        'ambient_eco2': HistoryDataPointItemToJSON(value['ambientEco2']),
        'ambient_humidity': HistoryDataPointItemToJSON(value['ambientHumidity']),
        'ambient_temperature': HistoryDataPointItemToJSON(value['ambientTemperature']),
        'ambient_tvoc': HistoryDataPointItemToJSON(value['ambientTvoc']),
        'anti_freeze_protection_active': HistoryDataPointItemToJSON(value['antiFreezeProtectionActive']),
        'backup_heater_1_active': HistoryDataPointItemToJSON(value['backupHeater1Active']),
        'backup_heater_2_active': HistoryDataPointItemToJSON(value['backupHeater2Active']),
        'backup_heater_3_active': HistoryDataPointItemToJSON(value['backupHeater3Active']),
        'boiler_demand_active': HistoryDataPointItemToJSON(value['boilerDemandActive']),
        'boiler_dhw_valve_state': HistoryDataPointItemToJSON(value['boilerDhwValveState']),
        'boiler_element_active': HistoryDataPointItemToJSON(value['boilerElementActive']),
        'boiler_ntc_1_temperature': HistoryDataPointItemToJSON(value['boilerNtc1Temperature']),
        'boiler_ntc_2_temperature': HistoryDataPointItemToJSON(value['boilerNtc2Temperature']),
        'boiler_ntc_3_temperature': HistoryDataPointItemToJSON(value['boilerNtc3Temperature']),
        'boiler_ntc_4_temperature': HistoryDataPointItemToJSON(value['boilerNtc4Temperature']),
        'boiler_valve_zone_1_state_active': HistoryDataPointItemToJSON(value['boilerValveZone1StateActive']),
        'boiler_valve_zone_2_state_active': HistoryDataPointItemToJSON(value['boilerValveZone2StateActive']),
        'boiler_valve_zone_3_state_active': HistoryDataPointItemToJSON(value['boilerValveZone3StateActive']),
        'central_heating_enabled': HistoryDataPointItemToJSON(value['centralHeatingEnabled']),
        'central_heating_or_domestic_hot_water_active': HistoryDataPointItemToJSON(value['centralHeatingOrDomesticHotWaterActive']),
        'central_heating_pump_operation_hours': HistoryDataPointItemToJSON(value['centralHeatingPumpOperationHours']),
        'central_heating_pump_pwm': HistoryDataPointItemToJSON(value['centralHeatingPumpPwm']),
        'central_heating_pump_start_stop_count': HistoryDataPointItemToJSON(value['centralHeatingPumpStartStopCount']),
        'central_heating_temperature_too_high': HistoryDataPointItemToJSON(value['centralHeatingTemperatureTooHigh']),
        'central_heating_total_energy_consumed': HistoryDataPointItemToJSON(value['centralHeatingTotalEnergyConsumed']),
        'central_heating_water_pressure': HistoryDataPointItemToJSON(value['centralHeatingWaterPressure']),
        'compressor_anti_toggle_active': HistoryDataPointItemToJSON(value['compressorAntiToggleActive']),
        'compressor_enabled': HistoryDataPointItemToJSON(value['compressorEnabled']),
        'compressor_operation_hours': HistoryDataPointItemToJSON(value['compressorOperationHours']),
        'compressor_total_energy_consumed': HistoryDataPointItemToJSON(value['compressorTotalEnergyConsumed']),
        'connected': HistoryDataPointItemToJSON(value['connected']),
        'cop': HistoryDataPointItemToJSON(value['cop']),
        'disconnect_reason': HistoryDataPointItemToJSON(value['disconnectReason']),
        'external_air_exhaust_flow': HistoryDataPointItemToJSON(value['externalAirExhaustFlow']),
        'external_air_intake_flow': HistoryDataPointItemToJSON(value['externalAirIntakeFlow']),
        'external_temperature_sensor_active': HistoryDataPointItemToJSON(value['externalTemperatureSensorActive']),
        'filter_change_required_within_days': HistoryDataPointItemToJSON(value['filterChangeRequiredWithinDays']),
        'heat_pump_air_exhaust_temperature': HistoryDataPointItemToJSON(value['heatPumpAirExhaustTemperature']),
        'heat_pump_auxiliary_heating_degree_minutes': HistoryDataPointItemToJSON(value['heatPumpAuxiliaryHeatingDegreeMinutes']),
        'heat_pump_condensation_pressure': HistoryDataPointItemToJSON(value['heatPumpCondensationPressure']),
        'heat_pump_condensation_temperature': HistoryDataPointItemToJSON(value['heatPumpCondensationTemperature']),
        'heat_pump_condenser_refrigerant_out_temperature': HistoryDataPointItemToJSON(value['heatPumpCondenserRefrigerantOutTemperature']),
        'heat_pump_current_compressor_speed': HistoryDataPointItemToJSON(value['heatPumpCurrentCompressorSpeed']),
        'heat_pump_defrost_freezing_value': HistoryDataPointItemToJSON(value['heatPumpDefrostFreezingValue']),
        'heat_pump_defrost_freezing_value_threshold': HistoryDataPointItemToJSON(value['heatPumpDefrostFreezingValueThreshold']),
        'heat_pump_desired_air_indoor_valve_setpoint': HistoryDataPointItemToJSON(value['heatPumpDesiredAirIndoorValveSetpoint']),
        'heat_pump_desired_air_outdoor_valve_setpoint': HistoryDataPointItemToJSON(value['heatPumpDesiredAirOutdoorValveSetpoint']),
        'heat_pump_desired_compressor_speed': HistoryDataPointItemToJSON(value['heatPumpDesiredCompressorSpeed']),
        'heat_pump_desired_reverse_cycle_position_is_cooling': HistoryDataPointItemToJSON(value['heatPumpDesiredReverseCyclePositionIsCooling']),
        'heat_pump_determined_air_fan_speed_setpoint': HistoryDataPointItemToJSON(value['heatPumpDeterminedAirFanSpeedSetpoint']),
        'heat_pump_determined_air_indoor_valve_position': HistoryDataPointItemToJSON(value['heatPumpDeterminedAirIndoorValvePosition']),
        'heat_pump_determined_air_outdoor_valve_position': HistoryDataPointItemToJSON(value['heatPumpDeterminedAirOutdoorValvePosition']),
        'heat_pump_determined_central_heating_supply_temperature': HistoryDataPointItemToJSON(value['heatPumpDeterminedCentralHeatingSupplyTemperature']),
        'heat_pump_determined_compressor_speed': HistoryDataPointItemToJSON(value['heatPumpDeterminedCompressorSpeed']),
        'heat_pump_determined_superheat_expansion_valve_position': HistoryDataPointItemToJSON(value['heatPumpDeterminedSuperheatExpansionValvePosition']),
        'heat_pump_determined_water_pump_speed_setpoint': HistoryDataPointItemToJSON(value['heatPumpDeterminedWaterPumpSpeedSetpoint']),
        'heat_pump_evaporation_pressure': HistoryDataPointItemToJSON(value['heatPumpEvaporationPressure']),
        'heat_pump_evaporation_temperature': HistoryDataPointItemToJSON(value['heatPumpEvaporationTemperature']),
        'heat_pump_evaporator_refrigerant_out_temperature': HistoryDataPointItemToJSON(value['heatPumpEvaporatorRefrigerantOutTemperature']),
        'heat_pump_hot_gas_temperature': HistoryDataPointItemToJSON(value['heatPumpHotGasTemperature']),
        'heat_pump_inverter_fault_code': HistoryDataPointItemToJSON(value['heatPumpInverterFaultCode']),
        'heat_pump_inverter_input_power': HistoryDataPointItemToJSON(value['heatPumpInverterInputPower']),
        'heat_pump_maximum_compressor_speed_envelope': HistoryDataPointItemToJSON(value['heatPumpMaximumCompressorSpeedEnvelope']),
        'heat_pump_maximum_compressor_speed_hotgas': HistoryDataPointItemToJSON(value['heatPumpMaximumCompressorSpeedHotgas']),
        'heat_pump_minimum_compressor_speed_envelope': HistoryDataPointItemToJSON(value['heatPumpMinimumCompressorSpeedEnvelope']),
        'heat_pump_room_setpoint_temperature': HistoryDataPointItemToJSON(value['heatPumpRoomSetpointTemperature']),
        'heat_pump_spare_temperature': HistoryDataPointItemToJSON(value['heatPumpSpareTemperature']),
        'heat_pump_total_operation_hours': HistoryDataPointItemToJSON(value['heatPumpTotalOperationHours']),
        'heat_recovery_valve_central_heating_active': HistoryDataPointItemToJSON(value['heatRecoveryValveCentralHeatingActive']),
        'heat_recovery_valve_half_active': HistoryDataPointItemToJSON(value['heatRecoveryValveHalfActive']),
        'hot_water_capacity': HistoryDataPointItemToJSON(value['hotWaterCapacity']),
        'hot_water_setpoint': HistoryDataPointItemToJSON(value['hotWaterSetpoint']),
        'hot_water_temperature': HistoryDataPointItemToJSON(value['hotWaterTemperature']),
        'internal_air_intake_flow': HistoryDataPointItemToJSON(value['internalAirIntakeFlow']),
        'legionella_prevention_active': HistoryDataPointItemToJSON(value['legionellaPreventionActive']),
        'nightclock_active': HistoryDataPointItemToJSON(value['nightclockActive']),
        'performance_energy_consumption_l1': HistoryDataPointItemToJSON(value['performanceEnergyConsumptionL1']),
        'performance_energy_consumption_l2': HistoryDataPointItemToJSON(value['performanceEnergyConsumptionL2']),
        'performance_energy_consumption_l3': HistoryDataPointItemToJSON(value['performanceEnergyConsumptionL3']),
        'performance_power_usage_l1': HistoryDataPointItemToJSON(value['performancePowerUsageL1']),
        'performance_power_usage_l2': HistoryDataPointItemToJSON(value['performancePowerUsageL2']),
        'performance_power_usage_l3': HistoryDataPointItemToJSON(value['performancePowerUsageL3']),
        'pure_air_air_in_temperature': HistoryDataPointItemToJSON(value['pureAirAirInTemperature']),
        'pure_air_air_out_temperature': HistoryDataPointItemToJSON(value['pureAirAirOutTemperature']),
        'pure_air_determined_fan_speed_setpoint': HistoryDataPointItemToJSON(value['pureAirDeterminedFanSpeedSetpoint']),
        'pure_air_estimated_water_valve_position': HistoryDataPointItemToJSON(value['pureAirEstimatedWaterValvePosition']),
        'pure_air_fan_speed': HistoryDataPointItemToJSON(value['pureAirFanSpeed']),
        'requested_heating_temperature': HistoryDataPointItemToJSON(value['requestedHeatingTemperature']),
        'reverse_cycle_position_is_cooling': HistoryDataPointItemToJSON(value['reverseCyclePositionIsCooling']),
        'room_current_uba': HistoryDataPointItemToJSON(value['roomCurrentUba']),
        'supplied_energy_central_heating': HistoryDataPointItemToJSON(value['suppliedEnergyCentralHeating']),
        'supplied_energy_domestic_hot_water': HistoryDataPointItemToJSON(value['suppliedEnergyDomesticHotWater']),
        'supplied_energy_heat_recovery_module': HistoryDataPointItemToJSON(value['suppliedEnergyHeatRecoveryModule']),
        'system_active': HistoryDataPointItemToJSON(value['systemActive']),
        'thermostat_hybrid_ch_enable': HistoryDataPointItemToJSON(value['thermostatHybridChEnable']),
        'ventilation_requested_auto_demand': HistoryDataPointItemToJSON(value['ventilationRequestedAutoDemand']),
        'ventilation_total_energy_consumed': HistoryDataPointItemToJSON(value['ventilationTotalEnergyConsumed']),
        'ventilator_operation_hours': HistoryDataPointItemToJSON(value['ventilatorOperationHours']),
        'ventilator_pwm': HistoryDataPointItemToJSON(value['ventilatorPwm']),
        'water_condenser_water_out_temperature': HistoryDataPointItemToJSON(value['waterCondenserWaterOutTemperature']),
        'water_flow': HistoryDataPointItemToJSON(value['waterFlow']),
        'water_pump_flow': HistoryDataPointItemToJSON(value['waterPumpFlow']),
        'water_pump_status': HistoryDataPointItemToJSON(value['waterPumpStatus']),
        'water_return_temperature': HistoryDataPointItemToJSON(value['waterReturnTemperature']),
        'water_supply_temperature': HistoryDataPointItemToJSON(value['waterSupplyTemperature']),
        'device_id': value['deviceId'],
        'device_changed': DevicesChangedToJSON(value['deviceChanged']),
    };
}

